import script from "./AppCompanyRecordInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppCompanyRecordInput.vue?vue&type=script&lang=ts&setup=true"

import "./AppCompanyRecordInput.vue?vue&type=style&index=0&id=21c4f528&scoped=true&lang=css"

import exportComponent from "/builds/nmhwyAssu/0/batesbus/app.securechannel.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c4f528"]])

export default __exports__